export const ContractDocType = {
    ContractProposition: 1,
    GreenCardWithPostalOrder: 2,
    GreenCard: 3,
    ContractSuccessConfirmation: 4,
    AssistanceCard: 5,
    PhotoDocumentation: 6,
    GreenCardGreen: 7,
    GreenCardWhite: 8,
    Insurance: 101,
    CestneProhlaseniZabezpeceni: 102,
    ClientCoupon: 103,
    SixthSence: 104,
    ClientCoupon2: 105,
    TriletaGarance: 106,
    CestneProhlaseniZtp: 107,
    SouhrnVpp: 108,
    DodatekPojistnePodleKm: 109,
    DodatekPojistnePodleKm2: 111,
    DohodaOZpusobuPlaceni: 110,
    ContractPropositionENG: 115,
    CommunicationRecord: 201,
    CKPRecord: 202,
    ProformaInvoice: 203,
    SouhlasManzelaKy: 204,
    FeesList: 205,
    InformationObligation: 206,
    BonusTransferAgreement: 207,
    CoveringLetter: 208,
    AssistanceSummary: 211,
    MergedDocuments: 1000,
    LegalDocument: 2000,
    LegalDocument2: 2001,
    LegalDocument3: 2002,
    LegalDocument4: 2003,
    LegalDocument5: 2004,
    LegalDocument6: 2005,
    LegalDocument7: 2006,
    LegalDocument8: 2007,
    LegalDocumentVpp: 2008,
    LegalDocument9: 2009,
    LegalDocument10: 2010,
    LegalDocument11: 2011,
    LegalDocument12: 2012,
    LegalDocument13: 2013,
    LegalDocument14: 2014,
    LegalDocument15: 2015,
    LegalDocument16: 2016,
    LegalDocument17: 2017,
    LegalDocument18: 2018,
    LegalDocument19: 2019,
    LegalDocument20: 2020,
    PreContractDocument: 3000,
    ClientInformation: 3010,
    UserAgreement: 3020,
    InformationMemorandum: 3030,
    InformationMemorandumInsurer: 3031,
    GdprInformation: 3040,
    GdprAgreementMarketing: 3041,
    ContractEmail: 3050,
    AccidentReport: 3051,
    CommunicationRecord2: 3042,
    CppRenomiaAutoStatement: 4000,
    CppRenomiaAutoHavAgrrement: 4001,
    AllianzContractStatement: 4002,
    CppOkAutoHavStatement: 4003,
    CppOkAutoDiscountStatement: 4004,
    CppAutoStatement: 4005,
    RenaultInstructions: 4006,
    VinkulaceDocument: 4007,
    IPID: 4008,
    FirstPayment: 4009,
    ProviderInformation: 4010,
    PriceList: 4011,
    IPZOP: 4012,
    VinkulaceDocumentInsurer: 4013,
    DaciaInstructions: 4014,
    LeafletRenault: 4015,
    LeafletDacia: 4016,
    CebiaCouponOcis: 5000,
    APC: 6000,
    CebiCatReport: 7000,
    PdfCalculation: 8000
} as const

export type ContractDocType = typeof ContractDocType[keyof typeof ContractDocType]

export function getContractDocTypeName(type?: ContractDocType): string {
    if (type === undefined || type === null) return ''
    const entry = Object.entries(ContractDocType).find(([_, value]) => value === type)
    return entry ? entry[0] : 'Neznámý dokument'
}